/**
 * Digits of the widest marker an ordered list prints ("98." .. "102." is 3): its first number plus the item count.
 * The list's gutter grows with it (markdown-list.css), so no number width can overflow the message column.
 */
export function olGutterDigits(start: number | undefined, items: number): number {
  const first = Number.isInteger(start) ? (start as number) : 1;
  const last = Math.max(Math.abs(first), Math.abs(first + Math.max(items, 1) - 1));
  return String(last).length + (first < 0 ? 1 : 0);
}
